import { Injectable } from '@angular/core';
import { filter } from 'rxjs/operators';
import { InteractionStatus } from '@azure/msal-browser';
import { CurrentUserLoad } from '../store/actions';
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { Store } from '@ngrx/store';
import { UserAvatarService } from '../services/user-avatar.service';

@Injectable({ providedIn: 'root' })
export class UserFacade {
  constructor(
    private readonly msalBroadcastService: MsalBroadcastService,
    private readonly authService: MsalService,
    private store: Store,
    private readonly userAvatar: UserAvatarService,
  ) {}

  public async init() {
    this.msalBroadcastService.inProgress$.pipe(filter((status: InteractionStatus) => status === InteractionStatus.None)).subscribe(() => {
      this.authService.instance.handleRedirectPromise();
    });

    await this.authService.instance.handleRedirectPromise();
    const accounts = this.authService.instance.getAllAccounts();

    if (!accounts.length) {
      await this.authService.instance.loginRedirect();
    } else {
      this.store.dispatch(new CurrentUserLoad());
      this.userAvatar.loadAvatar();
    }
  }
}
